import React from "react"
import { Typography, Grid } from "@material-ui/core"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import BlockBodySectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionContainer"

import { getAIConditionMatchDefaultValidation } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

import { colors } from "@/styles/colors"

type AIIntentionSectionContainerProps = {
	chatBotFlowBlockRule: ChatBotFlowBlockRule
	chatBotFlowBlockId: number
}

const AIIntentionSectionContainer: React.FC<AIIntentionSectionContainerProps> = (props) => {
	const {
		chatBotFlowBlockRule,
		chatBotFlowBlockId
	} = props

	const aiConditionMatchDefaultValidation = getAIConditionMatchDefaultValidation(chatBotFlowBlockRule)

	const title = aiConditionMatchDefaultValidation?.extra_data?.ai_condition?.title

	return (
		<BlockBodySectionContainer
			backgroundColor={colors.blue[50]}
			chatBotFlowBlockId={chatBotFlowBlockId}
			text={(
				<Grid
					container
				>
					<Grid
						item
						xs={12}
					>
						<Typography
							variant="caption"
							color="textPrimary"
						>
							Se a intenção da mensagem recebida for
						</Typography>
					</Grid>
					<Grid
						item
						xs={12}
					>
						<Typography
							variant="caption"
							color="textPrimary"
						>
							<b>{title}</b>
						</Typography>
					</Grid>
				</Grid>
			)}
		/>
	)
}

export default AIIntentionSectionContainer
